import { Link } from 'react-router-dom'
import { seo } from '@shared/seo.config'
import { cn } from '@/lib/utils'

// ─────────────────────────────────────────────────────────────────────────────
// BRAND — the site's mark and wordmark, used in the header and footer.
//
// BrandMark is an inline SVG that uses `currentColor` only, so it inherits the
// text colour of wherever it sits and is correct in both themes with no extra
// rule. It is a rounded square outline with a bold diagonal stroke and a dot —
// simple, geometric, readable at 16px.
// ─────────────────────────────────────────────────────────────────────────────

export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
      className={cn('size-6', className)}
    >
      <rect x="2.5" y="2.5" width="19" height="19" rx="5" stroke="currentColor" strokeWidth="2" />
      <path d="M6.5 17.5 17.5 6.5" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
      <circle cx="17.5" cy="17.5" r="2.2" fill="currentColor" />
    </svg>
  )
}

/** The wordmark: the mark in a primary tile, followed by the site name. */
export function Brand({ className }: { className?: string }) {
  return (
    <Link to="/" className={cn('flex shrink-0 items-center gap-2.5', className)}>
      <span data-upbo-src="src/components/Brand.tsx:33" className="grid size-8 place-items-center rounded-lg bg-primary text-primary-foreground">
        <BrandMark className="size-5" />
      </span>
      <span data-upbo-src="src/components/Brand.tsx:36" className="font-display text-sm font-semibold tracking-tight">{seo.siteName}</span>
    </Link>
  )
}